/**
 * VOITKUS Brew Timer — timestamp engine, hash router, localStorage.
 * Official + community recipes from window.voitkusBrewTimer (Liquid blocks).
 * User recipes in localStorage. Submit → Shopify contact form, live after you add a block.
 */
(function () {
  'use strict';

  var KEY_RECIPES = 'voitkus_brew_recipes';
  var KEY_PREFS = 'voitkus_brew_preferences';
  var KEY_HISTORY = 'voitkus_brew_history';
  var KEY_ACTIVE = 'voitkus_brew_active';
  var KEY_SUBMITTED = 'voitkus_brew_submitted';
  var SCHEMA = 1;

  var METHODS = ['v60', 'origami', 'aeropress', 'switch', 'chemex', 'french-press', 'other'];
  var STEP_TYPES = ['pour', 'wait', 'stir', 'swirl', 'open', 'close', 'press', 'finish', 'custom'];
  var GRINDS = ['fine', 'medium-fine', 'medium', 'medium-coarse', 'coarse'];

  var METHOD_LABEL = {
    v60: 'V60',
    origami: 'Origami',
    aeropress: 'AeroPress',
    switch: 'Hario Switch',
    chemex: 'Chemex',
    'french-press': 'French Press',
    other: 'Inne',
  };
  var STEP_LABEL = {
    pour: 'Lej',
    wait: 'Czekaj',
    stir: 'Mieszaj',
    swirl: 'Zakręć',
    open: 'Otwórz',
    close: 'Zamknij',
    press: 'Press',
    finish: 'Koniec',
    custom: 'Własny',
  };
  var GRIND_LABEL = {
    fine: 'Drobne',
    'medium-fine': 'Średnio-drobne',
    medium: 'Średnie',
    'medium-coarse': 'Średnio-grube',
    coarse: 'Grube',
  };

  var I18N = {
    eye: 'Brew Timer',
    title: 'Zaparzenie, nie stoper.',
    lead: 'Wybierz przepis. Timer powie, kiedy lać i do ilu gramów. Reszta — na wadze.',
    useRecipe: 'Użyj przepisu',
    createRecipe: 'Stwórz przepis',
    myRecipes: 'Moje przepisy',
    library: 'Biblioteka',
    startBrewing: 'Start',
    customize: 'Dostosuj',
    changeDose: 'Zmień dawkę',
    editRecipe: 'Edytuj',
    saveRecipe: 'Zapisz przepis',
    deleteRecipe: 'Usuń',
    brewAgain: 'Zaparzyć ponownie',
    adjustRecipe: 'Popraw przepis',
    saveBrew: 'Zapisz parzenie',
    pause: 'Pauza',
    resume: 'Wznów',
    stop: 'Stop',
    prevStep: 'Poprzedni',
    nextStep: 'Następny',
    sound: 'Dźwięk',
    vibration: 'Wibracja',
    emptyMine: 'Nie masz jeszcze swoich przepisów.',
    resumeBrew: 'Wznów parzenie',
    discardBrew: 'Odrzuć',
    scaleNote: 'Ilość wody została przeskalowana. Czasy kroków bez zmian.',
    unusedWater: 'Przepis zostawia niewykorzystaną wodę.',
    brewComplete: 'Gotowe',
    paused: 'Pauza',
    next: 'Dalej',
    cancel: 'Anuluj',
    startNow: 'Start teraz',
    soon: 'Zaraz',
    community: 'Społeczność',
    communityEye: 'Społeczność VOITKUS',
    emptyCommunity: 'Jeszcze nie ma przepisów społeczności.',
    submitCommunity: 'Wyślij do weryfikacji',
    submitted: 'Wysłano. Pojawi się po weryfikacji.',
    submitNeedAuthor: 'Podaj imię i nazwisko autora — nie „Ja”.',
    submitNeedNotes: 'Opisz przepis: co i dlaczego.',
    submitNeedEmail: 'Podaj email — zgłoszenie idzie do palarni.',
    submitFail: 'Nie udało się wysłać. Spróbuj ponownie.',
  };

  var cfg = window.voitkusBrewTimer || {};
  var T = Object.assign({}, I18N, cfg.i18n || {});
  if (Array.isArray(cfg.methods) && cfg.methods.length) METHODS = cfg.methods.slice();
  if (Array.isArray(cfg.stepTypes) && cfg.stepTypes.length) STEP_TYPES = cfg.stepTypes.slice();

  var root = document.querySelector('[data-brew-timer]');
  if (!root) return;

  var S = {
    official: [],
    user: [],
    prefs: { sound: false, vibrate: true, countdown: true },
    route: { name: 'home', id: '', query: {} },
    filterMethod: 'all',
    editor: null,
    doseModal: null,
    scaled: {},
    brew: null,
    lastSession: null,
    toast: '',
    ticking: false,
    brewViewKey: '',
    submitting: false,
    submitEmail: '',
  };

  var wakeLock = null;
  var audioCtx = null;
  var tickTimer = 0;
  var toastTimer = 0;

  /* ---------- core ---------- */

  function uid(prefix) {
    var p = prefix || 'id';
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return p + '_' + crypto.randomUUID();
    return p + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function h(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function roundDose(n) {
    return Math.round(Number(n) * 10) / 10;
  }

  function roundWater(n) {
    return Math.round(Number(n));
  }

  function calculateRatio(coffee, water) {
    var c = Number(coffee);
    var w = Number(water);
    if (!c || c <= 0) return 0;
    return Math.round((w / c) * 100) / 100;
  }

  function formatRatio(coffee, water) {
    var r = calculateRatio(coffee, water);
    if (!r) return '—';
    var t = Math.round(r * 10) / 10;
    return '1:' + (t % 1 === 0 ? String(t) : t.toFixed(1));
  }

  function formatTime(seconds) {
    var s = Math.max(0, Math.floor(Number(seconds) || 0));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return String(m).padStart(2, '0') + ':' + String(r).padStart(2, '0');
  }

  function parseTime(raw) {
    var str = String(raw || '').trim();
    if (!str) return 0;
    if (/^\d+:\d{1,2}$/.test(str)) {
      var p = str.split(':');
      return Math.max(0, parseInt(p[0], 10) * 60 + parseInt(p[1], 10));
    }
    var n = Number(str);
    return Number.isFinite(n) ? Math.max(0, Math.round(n)) : 0;
  }

  function parseStepsText(text) {
    var steps = [];
    String(text || '').split(/\r?\n/).forEach(function (line, i) {
      line = String(line || '').trim();
      if (!line) return;
      var p = line.split('|').map(function (x) { return x.trim(); });
      var type = STEP_TYPES.indexOf(p[1]) >= 0 ? p[1] : 'custom';
      var weight = type === 'pour' ? (Number(p[2]) || 0) : null;
      steps.push({
        id: 's' + i,
        time: parseTime(p[0] || '0'),
        type: type,
        targetWeight: weight,
        label: p[3] ? p[3] : null,
      });
    });
    return steps;
  }

  function hydrateRecipe(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var next = clone(raw);
    if ((!Array.isArray(next.steps) || !next.steps.length) && next.stepsText) {
      next.steps = parseStepsText(next.stepsText);
    }
    if (next.targetTime && typeof next.targetTime === 'object') {
      next.targetTime = {
        min: typeof next.targetTime.min === 'string' ? parseTime(next.targetTime.min) : next.targetTime.min,
        max: typeof next.targetTime.max === 'string' ? parseTime(next.targetTime.max) : next.targetTime.max,
      };
    }
    return normalizeRecipe(next, next.source || 'voitkus');
  }

  function formatTarget(recipe) {
    if (!recipe || !recipe.targetTime) return '—';
    var a = recipe.targetTime.min;
    var b = recipe.targetTime.max;
    if (a == null && b == null) return '—';
    if (a == null) return formatTime(b);
    if (b == null || a === b) return formatTime(a);
    return formatTime(a) + '–' + formatTime(b);
  }

  function sortSteps(steps) {
    return (steps || []).slice().sort(function (a, b) {
      var d = (Number(a.time) || 0) - (Number(b.time) || 0);
      return d !== 0 ? d : 0;
    });
  }

  function getCurrentStep(steps, elapsed) {
    var list = sortSteps(steps);
    if (!list.length) return null;
    var cur = list[0];
    for (var i = 0; i < list.length; i += 1) {
      if (elapsed >= (Number(list[i].time) || 0)) cur = list[i];
      else break;
    }
    return cur;
  }

  function getNextStep(steps, current) {
    var list = sortSteps(steps);
    if (!current) return list[0] || null;
    var idx = -1;
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].id === current.id) {
        idx = i;
        break;
      }
    }
    if (idx < 0) return null;
    return list[idx + 1] || null;
  }

  function lastPourWeight(steps) {
    var max = 0;
    var found = false;
    (steps || []).forEach(function (s) {
      if (s.type === 'pour' && s.targetWeight != null && s.targetWeight !== '') {
        found = true;
        max = Math.max(max, Number(s.targetWeight) || 0);
      }
    });
    return found ? max : null;
  }

  function validateRecipe(recipe) {
    var errors = [];
    var warnings = [];
    if (!recipe) return { ok: false, errors: ['Brak przepisu.'], warnings: warnings };
    if (!String(recipe.name || '').trim()) errors.push('Podaj nazwę przepisu.');
    var dose = Number(recipe.coffeeDose);
    var water = Number(recipe.water);
    if (!(dose > 0)) errors.push('Dawka kawy musi być większa od zera.');
    if (!(water > 0)) errors.push('Ilość wody musi być większa od zera.');
    var temp = Number(recipe.temperature);
    if (recipe.temperature != null && recipe.temperature !== '' && (temp < 70 || temp > 100)) {
      errors.push('Temperatura powinna być między 70°C a 100°C.');
    }
    var steps = sortSteps(recipe.steps || []);
    if (!steps.length) errors.push('Dodaj przynajmniej jeden krok.');
    var prevTime = -1;
    var prevPour = -1;
    steps.forEach(function (step, i) {
      var t = Number(step.time);
      if (!Number.isFinite(t) || t < 0) errors.push('Krok ' + (i + 1) + ': nieprawidłowy czas.');
      else if (t < prevTime) errors.push('Czas kroku ' + (i + 1) + ' nie może być wcześniejszy niż poprzedni.');
      if (Number.isFinite(t)) prevTime = t;
      if (step.type === 'pour') {
        var w = Number(step.targetWeight);
        if (!Number.isFinite(w) || w < 0) errors.push('Krok ' + (i + 1) + ': waga nie może być ujemna.');
        else {
          if (prevPour >= 0 && w < prevPour) {
            errors.push('Krok ' + (i + 1) + ': waga nalewania nie może spadać (skumulowana).');
          }
          prevPour = w;
        }
      }
      if (step.type === 'finish' && i !== steps.length - 1) {
        errors.push('Finish musi być ostatnim krokiem.');
      }
    });
    if (steps.length && steps[steps.length - 1].type !== 'finish') {
      errors.push('Ostatni krok musi być typu Finish.');
    }
    var last = lastPourWeight(steps);
    if (last != null && water > 0 && last > water) {
      errors.push('Ostatnie nalewanie przekracza całkowitą ilość wody.');
    }
    if (last != null && water > 0 && last < water) {
      warnings.push(T.unusedWater + ' ' + roundWater(water - last) + ' g.');
    }
    return { ok: errors.length === 0, errors: errors, warnings: warnings };
  }

  function scaleRecipe(recipe, newDose) {
    var next = clone(recipe);
    var from = Number(recipe.coffeeDose) || 0;
    var to = Number(newDose) || 0;
    if (!(from > 0) || !(to > 0)) return next;
    var factor = to / from;
    next.coffeeDose = roundDose(to);
    next.water = roundWater(recipe.water * factor);
    next.ratio = calculateRatio(next.coffeeDose, next.water);
    next.steps = (recipe.steps || []).map(function (step) {
      var s = clone(step);
      if (s.targetWeight != null && s.targetWeight !== '') {
        s.targetWeight = roundWater(Number(s.targetWeight) * factor);
      }
      return s;
    });
    next.scaled = true;
    return next;
  }

  function stepTitle(step) {
    if (!step) return '';
    if (step.type === 'pour' && step.targetWeight != null) {
      var pour = STEP_LABEL.pour + ' → ' + step.targetWeight + ' g';
      return step.label ? pour + ' · ' + step.label : pour;
    }
    if (step.label) return (STEP_LABEL[step.type] || step.type) + ' · ' + step.label;
    return STEP_LABEL[step.type] || step.type || 'Krok';
  }

  function normalizeStep(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var type = STEP_TYPES.indexOf(raw.type) >= 0 ? raw.type : 'custom';
    var weight = raw.targetWeight;
    if (weight === '' || weight == null) weight = null;
    else weight = Number(weight);
    return {
      id: String(raw.id || uid('step')),
      time: Math.max(0, Number(raw.time) || 0),
      type: type,
      targetWeight: type === 'pour' ? (Number.isFinite(weight) ? weight : 0) : null,
      label: raw.label ? String(raw.label) : null,
    };
  }

  function normalizeRecipe(raw, fallbackSource) {
    if (!raw || typeof raw !== 'object') return null;
    var dose = Number(raw.coffeeDose);
    var water = Number(raw.water);
    var steps = Array.isArray(raw.steps) ? raw.steps.map(normalizeStep).filter(Boolean) : [];
    var grind = raw.grind && typeof raw.grind === 'object' ? raw.grind : {};
    var target = raw.targetTime && typeof raw.targetTime === 'object' ? raw.targetTime : {};
    var source = raw.source === 'user' || raw.source === 'community' || raw.source === 'voitkus'
      ? raw.source
      : (fallbackSource || 'user');
    var method = METHODS.indexOf(raw.method) >= 0 ? raw.method : 'other';
    return {
      id: String(raw.id || uid('recipe')),
      name: String(raw.name || 'Przepis'),
      author: String(raw.author || (source === 'voitkus' ? 'VOITKUS' : 'Ja')),
      source: source,
      method: method,
      coffeeDose: Number.isFinite(dose) ? dose : 15,
      water: Number.isFinite(water) ? water : 250,
      temperature: raw.temperature == null || raw.temperature === '' ? 93 : Number(raw.temperature),
      ratio: calculateRatio(dose, water),
      grind: {
        level: GRINDS.indexOf(grind.level) >= 0 ? grind.level : 'medium-fine',
        grinder: grind.grinder ? String(grind.grinder) : null,
        setting: grind.setting ? String(grind.setting) : null,
      },
      targetTime: {
        min: target.min == null || target.min === '' ? null : Number(target.min),
        max: target.max == null || target.max === '' ? null : Number(target.max),
      },
      steps: sortSteps(steps),
      notes: raw.notes ? String(raw.notes) : '',
      coffeeName: raw.coffeeName ? String(raw.coffeeName) : '',
      visibility: raw.visibility === 'public' ? 'public' : 'private',
      coffeeId: raw.coffeeId || null,
      createdAt: raw.createdAt || null,
      updatedAt: raw.updatedAt || null,
    };
  }

  function emptyRecipe() {
    return {
      id: uid('recipe'),
      name: '',
      author: 'Ja',
      source: 'user',
      method: 'v60',
      coffeeDose: 15,
      water: 250,
      temperature: 93,
      ratio: calculateRatio(15, 250),
      grind: { level: 'medium-fine', grinder: null, setting: null },
      targetTime: { min: 150, max: 165 },
      steps: [
        { id: uid('step'), time: 0, type: 'pour', targetWeight: 50, label: 'Bloom' },
        { id: uid('step'), time: 150, type: 'finish', targetWeight: null, label: null },
      ],
      notes: '',
      coffeeName: '',
      visibility: 'private',
      coffeeId: null,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    };
  }

  /* ---------- storage ---------- */

  function readStore(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return fallback;
      var data = JSON.parse(raw);
      return data && typeof data === 'object' ? data : fallback;
    } catch (err) {
      return fallback;
    }
  }

  function writeStore(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (err) {
      return false;
    }
  }

  function loadUserRecipes() {
    var data = readStore(KEY_RECIPES, { version: SCHEMA, recipes: [] });
    var list = Array.isArray(data.recipes) ? data.recipes : [];
    S.user = list.map(function (r) { return normalizeRecipe(r, 'user'); }).filter(Boolean);
  }

  function saveUserRecipes() {
    writeStore(KEY_RECIPES, { version: SCHEMA, recipes: S.user });
  }

  function loadPrefs() {
    var data = readStore(KEY_PREFS, { version: SCHEMA, sound: false, vibrate: true, countdown: true });
    S.prefs.sound = !!data.sound;
    S.prefs.vibrate = data.vibrate !== false;
    S.prefs.countdown = data.countdown !== false;
  }

  function savePrefs() {
    writeStore(KEY_PREFS, {
      version: SCHEMA,
      sound: !!S.prefs.sound,
      vibrate: !!S.prefs.vibrate,
      countdown: !!S.prefs.countdown,
    });
  }

  function loadActive() {
    var data = readStore(KEY_ACTIVE, null);
    if (!data || !data.recipe || !data.state) return null;
    if (data.state === 'finished' || data.state === 'cancelled') return null;
    return data;
  }

  function saveActive() {
    if (!S.brew || S.brew.state === 'finished' || S.brew.state === 'cancelled') {
      try { localStorage.removeItem(KEY_ACTIVE); } catch (err) { /* ignore */ }
      return;
    }
    writeStore(KEY_ACTIVE, S.brew);
  }

  function appendHistory(session) {
    var data = readStore(KEY_HISTORY, { version: SCHEMA, items: [] });
    var items = Array.isArray(data.items) ? data.items : [];
    items.unshift(session);
    writeStore(KEY_HISTORY, { version: SCHEMA, items: items.slice(0, 50) });
  }

  function allRecipes() {
    return S.official.concat(S.user);
  }

  function findRecipe(id) {
    if (!id) return null;
    var i;
    for (i = 0; i < S.official.length; i += 1) if (S.official[i].id === id) return S.official[i];
    for (i = 0; i < S.user.length; i += 1) if (S.user[i].id === id) return S.user[i];
    return null;
  }

  function officialBySource(src) {
    return S.official.filter(function (r) { return r.source === src; });
  }

  function sourceLabel(recipe) {
    if (!recipe) return '';
    if (recipe.source === 'voitkus') return 'VOITKUS';
    return recipe.author || (recipe.source === 'community' ? T.community : 'Moje');
  }

  function loadSubmitted() {
    var data = readStore(KEY_SUBMITTED, { ids: [] });
    return Array.isArray(data.ids) ? data.ids : [];
  }

  function markSubmitted(id) {
    var ids = loadSubmitted();
    if (ids.indexOf(id) < 0) ids.push(id);
    writeStore(KEY_SUBMITTED, { ids: ids.slice(-80) });
  }

  function wasSubmitted(id) {
    return loadSubmitted().indexOf(id) >= 0;
  }

  function canSubmitAuthor(author) {
    var a = String(author || '').trim();
    return a.length >= 2 && !/^ja$/i.test(a);
  }

  function previewRecipe(id) {
    var base = findRecipe(id);
    if (!base) return null;
    return S.scaled[id] || base;
  }

  /* ---------- engine ---------- */

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function elapsedSec(brew) {
    if (!brew) return 0;
    if (brew.state === 'countdown' || brew.state === 'idle') return 0;
    if (brew.state === 'finished') return Number(brew.finishedElapsed) || 0;
    if (brew.state === 'paused') {
      return Math.max(0, (brew.pausedAt - brew.startedAt - brew.pauseAccum) / 1000);
    }
    return Math.max(0, (Date.now() - brew.startedAt - brew.pauseAccum) / 1000);
  }

  function finishAt(recipe) {
    var steps = sortSteps(recipe && recipe.steps);
    if (!steps.length) return 0;
    return Number(steps[steps.length - 1].time) || 0;
  }

  function displayStep(brew) {
    var auto = getCurrentStep(brew.recipe.steps, elapsedSec(brew));
    if (brew.manualIndex == null) return auto;
    var list = sortSteps(brew.recipe.steps);
    return list[brew.manualIndex] || auto;
  }

  function maybeClearManual(brew) {
    if (brew.manualIndex == null) return;
    var auto = getCurrentStep(brew.recipe.steps, elapsedSec(brew));
    var list = sortSteps(brew.recipe.steps);
    var autoIdx = -1;
    for (var i = 0; i < list.length; i += 1) {
      if (auto && list[i].id === auto.id) autoIdx = i;
    }
    if (autoIdx !== brew.autoIndexAtPin) brew.manualIndex = null;
  }

  function beep() {
    if (!S.prefs.sound) return;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      if (audioCtx.state === 'suspended') audioCtx.resume();
      var o = audioCtx.createOscillator();
      var g = audioCtx.createGain();
      o.type = 'sine';
      o.frequency.value = 660;
      g.gain.value = 0.03;
      o.connect(g);
      g.connect(audioCtx.destination);
      o.start();
      o.stop(audioCtx.currentTime + 0.08);
    } catch (err) { /* unavailable */ }
  }

  function buzz() {
    if (!S.prefs.vibrate || reduceMotion()) return;
    try { if (navigator.vibrate) navigator.vibrate(40); } catch (err) { /* unavailable */ }
  }

  function announceStep(brew) {
    var step = displayStep(brew);
    var id = step ? step.id : '';
    if (id && id !== brew.lastAnnouncedId) {
      brew.lastAnnouncedId = id;
      beep();
      buzz();
    }
  }

  function lockScreen() {
    if (!navigator.wakeLock) return;
    navigator.wakeLock.request('screen').then(function (lock) {
      wakeLock = lock;
    }).catch(function () {
      wakeLock = null;
    });
  }

  function unlockScreen() {
    if (wakeLock) {
      wakeLock.release().catch(function () {});
      wakeLock = null;
    }
  }

  function stopTick() {
    S.ticking = false;
    if (tickTimer) {
      clearInterval(tickTimer);
      tickTimer = 0;
    }
  }

  function startTick() {
    if (S.ticking) return;
    S.ticking = true;
    tickTimer = setInterval(onTick, 100);
  }

  function completeBrew(fromStop) {
    var brew = S.brew;
    if (!brew) return;
    var actual = fromStop ? elapsedSec(brew) : Math.max(elapsedSec(brew), finishAt(brew.recipe));
    brew.state = 'finished';
    brew.finishedElapsed = actual;
    brew.completedAt = Date.now();
    S.lastSession = {
      id: uid('brew'),
      recipeId: brew.recipe.id,
      recipeSnapshot: clone(brew.recipe),
      startedAt: brew.wallStartedAt || brew.startedAt,
      completedAt: brew.completedAt,
      actualTime: Math.round(actual),
      coffeeDose: brew.recipe.coffeeDose,
      water: brew.recipe.water,
      temperature: brew.recipe.temperature,
    };
    S.brew = null;
    unlockScreen();
    stopTick();
    try { localStorage.removeItem(KEY_ACTIVE); } catch (err) { /* ignore */ }
    location.hash = '#/done';
  }

  function brewViewKey(brew) {
    if (!brew) return '';
    if (brew.state === 'countdown') return 'c:' + countdownLabel(brew);
    var step = displayStep(brew);
    return brew.state + ':' + (step ? step.id : '') + ':' + brew.manualIndex + ':' + S.prefs.sound + ':' + S.prefs.vibrate;
  }

  function patchBrewClock() {
    var brew = S.brew;
    if (!brew) return;
    var clock = root.querySelector('.brew-timer-live__clock');
    if (clock) clock.textContent = formatTime(elapsedSec(brew));
    var count = root.querySelector('.brew-timer-live__count');
    if (count && brew.state === 'countdown') count.textContent = countdownLabel(brew);
  }

  function onTick() {
    var brew = S.brew;
    if (!brew) {
      stopTick();
      return;
    }
    if (brew.state === 'countdown') {
      if (Date.now() >= brew.countdownUntil) {
        brew.state = 'running';
        brew.startedAt = Date.now();
        brew.pauseAccum = 0;
        brew.pausedAt = 0;
        brew.lastAnnouncedId = '';
        lockScreen();
        beep();
        buzz();
        S.brewViewKey = '';
        paint();
        saveActive();
        return;
      }
      patchBrewClock();
      var cKey = brewViewKey(brew);
      if (cKey !== S.brewViewKey) {
        S.brewViewKey = cKey;
        paint();
      }
      return;
    }
    if (brew.state === 'running') {
      maybeClearManual(brew);
      if (elapsedSec(brew) >= finishAt(brew.recipe)) {
        beep();
        buzz();
        completeBrew(false);
        return;
      }
      announceStep(brew);
      patchBrewClock();
      var rKey = brewViewKey(brew);
      if (rKey !== S.brewViewKey) {
        S.brewViewKey = rKey;
        paint();
      }
    }
  }

  function beginBrew(recipe) {
    var snap = clone(recipe);
    var skip = reduceMotion() || !S.prefs.countdown;
    S.brew = {
      recipe: snap,
      state: skip ? 'running' : 'countdown',
      startedAt: skip ? Date.now() : 0,
      wallStartedAt: Date.now(),
      pauseAccum: 0,
      pausedAt: 0,
      countdownUntil: skip ? 0 : Date.now() + 3000,
      manualIndex: null,
      autoIndexAtPin: 0,
      lastAnnouncedId: '',
      finishedElapsed: 0,
      completedAt: 0,
    };
    saveActive();
    startTick();
    if (skip) lockScreen();
    location.hash = '#/brew';
  }

  function pauseBrew() {
    if (!S.brew || S.brew.state !== 'running') return;
    S.brew.state = 'paused';
    S.brew.pausedAt = Date.now();
    unlockScreen();
    stopTick();
    saveActive();
    paint();
  }

  function resumeBrew() {
    if (!S.brew || S.brew.state !== 'paused') return;
    S.brew.pauseAccum += Date.now() - S.brew.pausedAt;
    S.brew.pausedAt = 0;
    S.brew.state = 'running';
    lockScreen();
    saveActive();
    startTick();
    paint();
  }

  function stopBrew() {
    if (!S.brew) return;
    completeBrew(true);
  }

  function pinStep(delta) {
    var brew = S.brew;
    if (!brew || brew.state === 'countdown' || brew.state === 'finished') return;
    var list = sortSteps(brew.recipe.steps);
    var current = displayStep(brew);
    var idx = 0;
    for (var i = 0; i < list.length; i += 1) {
      if (current && list[i].id === current.id) idx = i;
    }
    var next = idx + delta;
    if (next < 0 || next >= list.length) return;
    var auto = getCurrentStep(list, elapsedSec(brew));
    var autoIdx = 0;
    for (i = 0; i < list.length; i += 1) {
      if (auto && list[i].id === auto.id) autoIdx = i;
    }
    brew.manualIndex = next;
    brew.autoIndexAtPin = autoIdx;
    brew.lastAnnouncedId = '';
    announceStep(brew);
    paint();
  }

  /* ---------- router ---------- */

  function parseHash() {
    var raw = (location.hash || '#/').replace(/^#/, '');
    var q = raw.indexOf('?');
    var path = q >= 0 ? raw.slice(0, q) : raw;
    var query = {};
    if (q >= 0) {
      raw.slice(q + 1).split('&').forEach(function (pair) {
        var kv = pair.split('=');
        if (kv[0]) query[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1] || '');
      });
    }
    var parts = path.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    if (!parts.length) return { name: 'home', id: '', query: query };
    if (parts[0] === 'recipes') return { name: 'recipes', id: '', query: query };
    if (parts[0] === 'recipe' && parts[1]) return { name: 'recipe', id: parts[1], query: query };
    if (parts[0] === 'create') return { name: 'create', id: '', query: query };
    if (parts[0] === 'edit' && parts[1]) return { name: 'edit', id: parts[1], query: query };
    if (parts[0] === 'brew') return { name: 'brew', id: '', query: query };
    if (parts[0] === 'done') return { name: 'done', id: '', query: query };
    return { name: 'home', id: '', query: query };
  }

  function go(hash) {
    location.hash = hash;
  }

  /* ---------- views ---------- */

  function btn(act, label, extra, attrs) {
    return (
      '<button type="button" class="brew-timer__btn' + (extra ? ' ' + extra : '') +
      '" data-act="' + h(act) + '"' + (attrs || '') + '>' + h(label) + '</button>'
    );
  }

  function back(hash, label) {
    return (
      '<button type="button" class="brew-timer__back" data-act="go" data-hash="' +
      h(hash) + '">← ' + h(label || 'Wróć') + '</button>'
    );
  }

  function card(recipe) {
    return (
      '<button type="button" class="brew-timer__card" data-act="go" data-hash="#/recipe/' + h(recipe.id) + '">' +
        '<p class="brew-timer__card-src">' + h(sourceLabel(recipe)) + '</p>' +
        '<p class="brew-timer__card-name">' + h(recipe.name) + '</p>' +
        '<p class="brew-timer__card-meta">' +
          h(METHOD_LABEL[recipe.method] || recipe.method) + ' · ' +
          h(recipe.coffeeDose) + ' g / ' + h(recipe.water) + ' g · ' +
          h(formatRatio(recipe.coffeeDose, recipe.water)) + ' · ' +
          h(formatTarget(recipe)) +
        '</p>' +
      '</button>'
    );
  }

  function chip(kind, value, label, current) {
    var on = (current || 'all') === value ? ' is-on' : '';
    return (
      '<button type="button" class="brew-timer__chip' + on + '" data-act="filter" data-kind="' +
      h(kind) + '" data-value="' + h(value) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
      h(label) + '</button>'
    );
  }

  function specCell(k, v) {
    return (
      '<div class="brew-timer__spec-cell"><span class="brew-timer__spec-k">' + h(k) +
      '</span><p class="brew-timer__spec-v">' + h(v) + '</p></div>'
    );
  }

  function grindText(recipe) {
    var g = recipe.grind || {};
    var bits = [GRIND_LABEL[g.level] || g.level || '—'];
    if (g.grinder) bits.push(g.grinder);
    if (g.setting) bits.push(g.setting);
    return bits.join(' · ');
  }

  function field(label, inner) {
    return '<label class="brew-timer__field"><span>' + h(label) + '</span>' + inner + '</label>';
  }

  function featuredBlock(label, recipes) {
    if (!recipes.length) return '';
    return (
      '<div class="brew-timer__block">' +
        '<p class="brew-timer__eye">' + h(label) + '</p>' +
        '<div class="brew-timer__featured">' + recipes.map(card).join('') + '</div>' +
      '</div>'
    );
  }

  function renderHome() {
    var voitkus = officialBySource('voitkus').slice(0, 4);
    var community = officialBySource('community').slice(0, 3);
    var resume = !S.brew ? loadActive() : null;
    var resumeHtml = '';
    if (resume && resume.recipe) {
      resumeHtml =
        '<div class="brew-timer__resume">' +
          '<p>Przerwane parzenie: <strong>' + h(resume.recipe.name) + '</strong></p>' +
          btn('resume-active', T.resumeBrew) +
          btn('discard-active', T.discardBrew, 'brew-timer__btn--ghost') +
        '</div>';
    }
    var featured = featuredBlock('VOITKUS', voitkus) + featuredBlock(T.communityEye, community);
    return (
      '<div class="brew-timer__hero-band">' +
        '<div class="brew-timer__inner brew-timer__hero">' +
          '<div class="brew-timer__dna">' +
            '<p class="brew-timer__eye">' + h(T.eye) + '</p>' +
            '<h1 class="brew-timer__h1">' + h(T.title) + '</h1>' +
            '<p class="brew-timer__lead">' + h(T.lead) + '</p>' +
            resumeHtml +
            '<div class="brew-timer__cta-row">' +
              btn('go', T.useRecipe, '', ' data-hash="#/recipes"') +
              btn('go', T.createRecipe, 'brew-timer__btn--ghost', ' data-hash="#/create"') +
              btn('go', T.myRecipes, 'brew-timer__btn--ghost', ' data-hash="#/recipes?source=user"') +
            '</div>' +
          '</div>' +
          '<aside class="brew-timer__spec" aria-label="Punkt startowy">' +
            '<p class="brew-timer__eye">Punkt startowy</p>' +
            '<div class="brew-timer__spec-grid">' +
              specCell('Kawa', '15 g') +
              specCell('Woda', '250 g') +
              specCell('Ratio', '1 : 16,7') +
              specCell('Zegar', 'timestamp') +
            '</div>' +
            '<p class="brew-timer__spec-note">Timer mówi, kiedy lać i do ilu gramów. Reszta — na wadze.</p>' +
          '</aside>' +
        '</div>' +
      '</div>' +
      (featured
        ? '<div class="brew-timer__band brew-timer__band--paper"><div class="brew-timer__inner">' + featured + '</div></div>'
        : '')
    );
  }

  function filteredList() {
    var source = S.route.query.source || 'all';
    var method = S.filterMethod;
    var list = allRecipes();
    if (source === 'user') list = S.user.slice();
    else if (source === 'voitkus') list = officialBySource('voitkus');
    else if (source === 'community') list = officialBySource('community');
    if (method && method !== 'all') {
      list = list.filter(function (r) { return r.method === method; });
    }
    return list;
  }

  function renderLibrary() {
    var source = S.route.query.source || 'all';
    var list = filteredList();
    var chips =
      '<div class="brew-timer__filters">' +
        chip('source', 'all', 'Wszystkie', source) +
        chip('source', 'voitkus', 'VOITKUS', source) +
        chip('source', 'community', T.community, source) +
        chip('source', 'user', 'Moje', source) +
      '</div>' +
      '<div class="brew-timer__filters">' +
        chip('method', 'all', 'Metoda', S.filterMethod) +
        METHODS.map(function (m) {
          return chip('method', m, METHOD_LABEL[m] || m, S.filterMethod);
        }).join('') +
      '</div>';
    var body = list.length
      ? '<div class="brew-timer__list">' + list.map(card).join('') + '</div>'
      : '<p class="brew-timer__empty">' + h(
          source === 'user' ? T.emptyMine : (source === 'community' ? T.emptyCommunity : 'Brak przepisów dla tych filtrów.')
        ) + '</p>';
    return (
      '<div class="brew-timer__inner">' +
        back('#/', T.eye) +
        '<div class="brew-timer__dna">' +
          '<p class="brew-timer__eye">' + h(T.library) + '</p>' +
          '<h1 class="brew-timer__h2">' + h(source === 'user' ? T.myRecipes : (source === 'community' ? T.community : T.library)) + '</h1>' +
        '</div>' +
        chips + body +
        '<div class="brew-timer__cta-row" style="margin-top:24px">' +
          btn('go', T.createRecipe, 'brew-timer__btn--ghost', ' data-hash="#/create"') +
        '</div>' +
      '</div>'
    );
  }

  function renderDoseModal(recipe) {
    var val = S.doseModal.value;
    return (
      '<div class="brew-timer__modal" data-act="close-modal">' +
        '<div class="brew-timer__dialog" role="dialog" aria-labelledby="dose-title" data-dialog>' +
          '<h2 id="dose-title">' + h(T.changeDose) + '</h2>' +
          '<p>' + h(T.scaleNote) + '</p>' +
          '<label class="brew-timer__field"><span>Kawa (g)</span>' +
            '<input type="number" inputmode="decimal" min="1" step="0.1" value="' + h(val) + '" data-dose-input>' +
          '</label>' +
          '<div class="brew-timer__cta-row">' +
            btn('apply-dose', 'Zastosuj', '', ' data-id="' + h(recipe.id) + '"') +
            btn('close-modal', 'Anuluj', 'brew-timer__btn--ghost') +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderPreview() {
    var recipe = previewRecipe(S.route.id);
    if (!recipe) {
      return '<div class="brew-timer__inner">' + back('#/recipes', T.library) + '<p>Nie znaleziono przepisu.</p></div>';
    }
    var v = validateRecipe(recipe);
    var isUser = recipe.source === 'user';
    var scaled = !!S.scaled[recipe.id] || !!recipe.scaled;
    var steps = sortSteps(recipe.steps).map(function (s) {
      return (
        '<li><time>' + formatTime(s.time) + '</time><b>' + h(stepTitle(s)) + '</b><em>' +
        h(STEP_LABEL[s.type] || '') + '</em></li>'
      );
    }).join('');
    return (
      '<div class="brew-timer__inner">' +
        back('#/recipes', T.library) +
        '<div class="brew-timer__preview">' +
          '<div class="brew-timer__dna">' +
            '<p class="brew-timer__eye">' + h(sourceLabel(recipe)) + '</p>' +
            '<h1 class="brew-timer__h2">' + h(recipe.name) + '</h1>' +
            (recipe.notes ? '<p class="brew-timer__lead brew-timer__body">' + h(recipe.notes) + '</p>' : '') +
            (scaled ? '<p class="brew-timer__note">' + h(T.scaleNote) + '</p>' : '') +
            (v.warnings.length ? '<p class="brew-timer__note brew-timer__note--warn">' + h(v.warnings.join(' ')) + '</p>' : '') +
          '</div>' +
          '<aside class="brew-timer__spec" aria-label="' + h(recipe.name) + '">' +
            '<p class="brew-timer__eye">' + h(sourceLabel(recipe)) + '</p>' +
            '<div class="brew-timer__spec-grid">' +
              specCell('Metoda', METHOD_LABEL[recipe.method] || recipe.method) +
              specCell('Kawa', recipe.coffeeDose + ' g') +
              specCell('Woda', recipe.water + ' g') +
              specCell('Ratio', formatRatio(recipe.coffeeDose, recipe.water)) +
              specCell('Temperatura', recipe.temperature + '°C') +
              specCell('Mielenie', grindText(recipe)) +
              specCell('Cel', formatTarget(recipe)) +
              specCell('Autor', recipe.author) +
              (recipe.coffeeName ? specCell('Lot', recipe.coffeeName) : '') +
            '</div>' +
          '</aside>' +
        '</div>' +
        '<ol class="brew-timer__score">' + steps + '</ol>' +
        '<div class="brew-timer__cta-row">' +
          btn('start', T.startBrewing, '', ' data-id="' + h(recipe.id) + '"') +
          btn('dose', T.changeDose, 'brew-timer__btn--ghost', ' data-id="' + h(recipe.id) + '"') +
          (isUser
            ? btn('go', T.editRecipe, 'brew-timer__btn--ghost', ' data-hash="#/edit/' + h(recipe.id) + '"')
            : btn('customize', T.customize, 'brew-timer__btn--ghost', ' data-id="' + h(recipe.id) + '"')) +
        '</div>' +
        (S.doseModal && S.doseModal.id === recipe.id ? renderDoseModal(recipe) : '') +
      '</div>'
    );
  }

  function renderEditor() {
    var recipe = S.editor;
    if (!recipe) {
      return '<div class="brew-timer__inner">' + back('#/', T.eye) + '<p>Brak przepisu do edycji.</p></div>';
    }
    var v = validateRecipe(recipe);
    var methodOpts = METHODS.map(function (m) {
      return '<option value="' + h(m) + '"' + (recipe.method === m ? ' selected' : '') + '>' + h(METHOD_LABEL[m] || m) + '</option>';
    }).join('');
    var grindOpts = GRINDS.map(function (g) {
      return '<option value="' + h(g) + '"' + ((recipe.grind && recipe.grind.level) === g ? ' selected' : '') + '>' + h(GRIND_LABEL[g] || g) + '</option>';
    }).join('');
    var steps = (recipe.steps || []).map(function (s, i) {
      var typeOpts = STEP_TYPES.map(function (t) {
        return '<option value="' + h(t) + '"' + (s.type === t ? ' selected' : '') + '>' + h(STEP_LABEL[t] || t) + '</option>';
      }).join('');
      var weight = s.type === 'pour'
        ? field('Waga (g, skumulowana)', '<input data-ed="targetWeight" data-i="' + i + '" type="number" min="0" step="1" value="' + h(s.targetWeight == null ? '' : s.targetWeight) + '">')
        : '';
      return (
        '<div class="brew-timer__step">' +
          '<div class="brew-timer__step-head"><span class="brew-timer__step-n">Krok ' + (i + 1) + '</span>' +
            '<div class="brew-timer__step-actions">' +
              '<button type="button" class="brew-timer__icon-btn" data-act="step-up" data-i="' + i + '" aria-label="W górę">↑</button>' +
              '<button type="button" class="brew-timer__icon-btn" data-act="step-down" data-i="' + i + '" aria-label="W dół">↓</button>' +
              '<button type="button" class="brew-timer__icon-btn" data-act="step-del" data-i="' + i + '" aria-label="Usuń krok">✕</button>' +
            '</div>' +
          '</div>' +
          '<div class="brew-timer__fields brew-timer__fields--2">' +
            field('Czas (mm:ss)', '<input data-ed="time" data-i="' + i + '" value="' + h(formatTime(s.time)) + '" inputmode="numeric">') +
            field('Akcja', '<select data-ed="type" data-i="' + i + '">' + typeOpts + '</select>') +
            weight +
            field('Notatka', '<input data-ed="label" data-i="' + i + '" value="' + h(s.label || '') + '">') +
          '</div>' +
        '</div>'
      );
    }).join('');
    return (
      '<div class="brew-timer__inner">' +
        back('#/', T.eye) +
        '<div class="brew-timer__dna">' +
          '<p class="brew-timer__eye">' + h(T.eye) + '</p>' +
          '<h1 class="brew-timer__h2">' + h(S.route.name === 'create' ? T.createRecipe : T.editRecipe) + '</h1>' +
        '</div>' +
        (v.errors.length ? '<div class="brew-timer__errors"><ul>' + v.errors.map(function (e) { return '<li>' + h(e) + '</li>'; }).join('') + '</ul></div>' : '') +
        (v.warnings.length ? '<p class="brew-timer__note brew-timer__note--warn">' + h(v.warnings.join(' ')) + '</p>' : '') +
        '<form class="brew-timer__form" data-editor-form>' +
          '<div class="brew-timer__form-block"><h3>Podstawowe</h3><div class="brew-timer__fields brew-timer__fields--2">' +
            field('Nazwa', '<input data-ed="name" value="' + h(recipe.name) + '">') +
            field('Autor', '<input data-ed="author" value="' + h(recipe.author) + '" placeholder="Imię i nazwisko">') +
            field('Email (zgłoszenie)', '<input data-ed="email" type="email" value="' + h(S.submitEmail || '') + '" autocomplete="email">') +
            field('Metoda', '<select data-ed="method">' + methodOpts + '</select>') +
            field('Lot / kawa', '<input data-ed="coffeeName" value="' + h(recipe.coffeeName || '') + '">') +
            field('Kawa (g)', '<input data-ed="coffeeDose" type="number" min="0.1" step="0.1" value="' + h(recipe.coffeeDose) + '">') +
            field('Woda (g)', '<input data-ed="water" type="number" min="1" step="1" value="' + h(recipe.water) + '">') +
          '</div><p class="brew-timer__ratio">' + h(formatRatio(recipe.coffeeDose, recipe.water)) + '</p>' +
            '<label class="brew-timer__field brew-timer__field--span"><span>Opis przepisu</span>' +
            '<textarea data-ed="notes" rows="4" maxlength="2000">' + h(recipe.notes || '') + '</textarea></label></div>' +
          '<div class="brew-timer__form-block"><h3>Parametry</h3><div class="brew-timer__fields brew-timer__fields--2">' +
            field('Temperatura (°C)', '<input data-ed="temperature" type="number" min="70" max="100" step="1" value="' + h(recipe.temperature) + '">') +
            field('Mielenie', '<select data-ed="grindLevel">' + grindOpts + '</select>') +
            field('Cel min (mm:ss)', '<input data-ed="tmin" value="' + h(recipe.targetTime.min != null ? formatTime(recipe.targetTime.min) : '') + '">') +
            field('Cel max (mm:ss)', '<input data-ed="tmax" value="' + h(recipe.targetTime.max != null ? formatTime(recipe.targetTime.max) : '') + '">') +
            field('Młynek (opcjonalnie)', '<input data-ed="grinder" value="' + h((recipe.grind && recipe.grind.grinder) || '') + '">') +
            field('Ustawienie młynka', '<input data-ed="setting" value="' + h((recipe.grind && recipe.grind.setting) || '') + '">') +
          '</div></div>' +
          '<div class="brew-timer__form-block"><h3>Kroki</h3>' + steps +
            '<div class="brew-timer__cta-row" style="margin-top:12px">' + btn('step-add', '+ Dodaj krok', 'brew-timer__btn--ghost') + '</div>' +
          '</div>' +
          '<div class="brew-timer__cta-row">' +
            btn('save', T.saveRecipe) +
            btn('save-brew', 'Zapisz i start', 'brew-timer__btn--ghost') +
            (recipe.source === 'user'
              ? (wasSubmitted(recipe.id)
                ? '<p class="brew-timer__note">' + h(T.submitted) + '</p>'
                : btn('submit-community', T.submitCommunity, 'brew-timer__btn--ghost' + (S.submitting ? ' is-wait' : ''), S.submitting ? ' disabled' : ''))
              : '') +
            (S.route.name === 'edit' && recipe.source === 'user' ? btn('delete', T.deleteRecipe, 'brew-timer__btn--danger') : '') +
          '</div>' +
        '</form>' +
      '</div>'
    );
  }

  function countdownLabel(brew) {
    var left = Math.ceil((brew.countdownUntil - Date.now()) / 1000);
    if (left >= 3) return '3';
    if (left >= 2) return '2';
    if (left >= 1) return '1';
    return 'START';
  }

  function renderBrew() {
    var brew = S.brew;
    if (!brew) {
      return '<div class="brew-timer__inner">' + back('#/', T.eye) + '<p>Brak aktywnego parzenia.</p></div>';
    }
    var recipe = brew.recipe;
    var paused = brew.state === 'paused';
    var counting = brew.state === 'countdown';
    var t = elapsedSec(brew);
    var step = counting ? null : displayStep(brew);
    var nxt = step ? getNextStep(recipe.steps, step) : sortSteps(recipe.steps)[0];
    var kind = counting ? 'Start' : (paused ? T.paused : (STEP_LABEL[step && step.type] || 'Krok'));
    var weight = counting || !step || step.targetWeight == null ? '' : (step.targetWeight + ' g');
    var nextLine = '';
    if (!counting && nxt) nextLine = T.next + ' · ' + formatTime(nxt.time) + ' · ' + stepTitle(nxt);
    var first = sortSteps(recipe.steps)[0];
    document.body.classList.add('brew-timer-lock');
    return (
      '<div class="brew-timer-live' + (paused ? ' is-paused' : '') + (counting ? ' is-count' : '') + '">' +
        '<header class="brew-timer-live__top">' +
          '<p class="brew-timer-live__method">' + h(METHOD_LABEL[recipe.method] || recipe.method) + '</p>' +
          '<p class="brew-timer-live__meta">' + h(recipe.coffeeDose) + ' g · ' + h(recipe.water) + ' g · ' + h(recipe.temperature) + '°C</p>' +
        '</header>' +
        '<section class="brew-timer-live__now">' +
          (counting
            ? '<p class="brew-timer-live__kind">Start</p>' +
              '<div class="brew-timer-live__stage">' +
                '<p class="brew-timer-live__count" aria-live="assertive">' + h(countdownLabel(brew)) + '</p>' +
                '<p class="brew-timer-live__recipe">' + h(recipe.name) + '</p>' +
              '</div>' +
              (first ? '<p class="brew-timer-live__next"><b>' + h(T.soon) + ' · ' + h(stepTitle(first)) + '</b></p>' : '')
            : '<p class="brew-timer-live__kind">' + h(kind) + '</p>' +
              '<div class="brew-timer-live__stage' + (weight ? ' has-weight' : '') + '">' +
                '<p class="brew-timer-live__clock">' + formatTime(t) + '</p>' +
                (weight ? '<p class="brew-timer-live__weight">' + h(weight) + '</p>' : '') +
                '<h1 class="brew-timer-live__action">' + h(step ? (step.label || STEP_LABEL[step.type] || '') : '') + '</h1>' +
              '</div>' +
              (nextLine ? '<p class="brew-timer-live__next"><b>' + h(nextLine) + '</b></p>' : '')) +
        '</section>' +
        '<footer>' +
          '<div class="brew-timer-live__row">' +
            btn('pref-sound', T.sound + (S.prefs.sound ? ' · on' : ' · off'), 'brew-timer__btn--ghost') +
            btn('pref-vib', T.vibration + (S.prefs.vibrate ? ' · on' : ' · off'), 'brew-timer__btn--ghost') +
          '</div>' +
          (counting
            ? '<div class="brew-timer-live__controls brew-timer-live__controls--count">' +
                btn('stop', T.cancel, 'brew-timer__btn--ghost') +
                btn('skip-count', T.startNow) +
              '</div>'
            : '<div class="brew-timer-live__row">' +
                btn('step-prev', T.prevStep, 'brew-timer__btn--ghost') +
                btn('step-next', T.nextStep, 'brew-timer__btn--ghost') +
                btn('stop', T.stop, 'brew-timer__btn--ghost') +
              '</div>' +
              '<div class="brew-timer-live__controls">' +
                btn(paused ? 'resume' : 'pause', paused ? T.resume : T.pause) +
              '</div>') +
        '</footer>' +
      '</div>'
    );
  }

  function renderDone() {
    var sess = S.lastSession;
    if (!sess) {
      return '<div class="brew-timer__inner">' + back('#/', T.eye) + '<p>Brak zakończonego parzenia.</p></div>';
    }
    var r = sess.recipeSnapshot;
    var unsaved = r.source === 'user' && !findRecipe(r.id);
    return (
      '<div class="brew-timer__inner">' +
        back('#/', T.library) +
        '<p class="brew-timer__eye">' + h(T.brewComplete) + '</p>' +
        '<h1 class="brew-timer__h1">' + formatTime(sess.actualTime) + '</h1>' +
        '<p class="brew-timer__lead">' + h(r.name) + '</p>' +
        '<div class="brew-timer__spec">' +
          specCell('Kawa', sess.coffeeDose + ' g') +
          specCell('Woda', sess.water + ' g') +
          specCell('Ratio', formatRatio(sess.coffeeDose, sess.water)) +
          specCell('Temperatura', sess.temperature + '°C') +
        '</div>' +
        '<div class="brew-timer__cta-row">' +
          btn('again', T.brewAgain) +
          btn('go', T.library, 'brew-timer__btn--ghost', ' data-hash="#/"') +
          btn('adjust', T.adjustRecipe, 'brew-timer__btn--ghost') +
          btn('save-session', T.saveBrew, 'brew-timer__btn--ghost') +
          (unsaved || r.scaled ? btn('save-from-done', T.saveRecipe, 'brew-timer__btn--ghost') : '') +
        '</div>' +
      '</div>'
    );
  }

  function paint() {
    if (!root) return;
    if (S.route.name !== 'brew') document.body.classList.remove('brew-timer-lock');
    var html = '';
    if (S.route.name === 'home') html = renderHome();
    else if (S.route.name === 'recipes') html = renderLibrary();
    else if (S.route.name === 'recipe') html = renderPreview();
    else if (S.route.name === 'create' || S.route.name === 'edit') html = renderEditor();
    else if (S.route.name === 'brew') html = renderBrew();
    else if (S.route.name === 'done') html = renderDone();
    else html = renderHome();
    if (S.toast) html += '<div class="brew-timer__toast" role="status">' + h(S.toast) + '</div>';
    root.innerHTML = html;
    if (S.brew) S.brewViewKey = brewViewKey(S.brew);
  }

  function toast(msg) {
    S.toast = msg;
    paint();
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      S.toast = '';
      paint();
    }, 2200);
  }

  /* ---------- mutations ---------- */

  function upsertUser(recipe) {
    var copy = normalizeRecipe(recipe, 'user');
    copy.source = 'user';
    copy.updatedAt = Date.now();
    copy.createdAt = copy.createdAt || Date.now();
    var idx = -1;
    for (var i = 0; i < S.user.length; i += 1) if (S.user[i].id === copy.id) idx = i;
    if (idx >= 0) S.user[idx] = copy;
    else S.user.unshift(copy);
    saveUserRecipes();
    return copy;
  }

  function customize(id) {
    var base = previewRecipe(id) || findRecipe(id);
    if (!base) return;
    var copy = clone(base);
    copy.id = uid('recipe');
    copy.name = /^mój /i.test(copy.name) ? copy.name : 'Mój ' + copy.name;
    copy.source = 'user';
    copy.author = 'Ja';
    copy.visibility = 'private';
    copy.createdAt = Date.now();
    copy.updatedAt = Date.now();
    S.editor = copy;
    go('#/edit/' + copy.id);
  }

  function readEditorFields() {
    if (!S.editor) return;
    var form = root.querySelector('[data-editor-form]');
    if (!form) return;
    var get = function (sel) {
      var el = form.querySelector(sel);
      return el ? el.value : '';
    };
    S.editor.name = get('[data-ed="name"]');
    S.editor.author = get('[data-ed="author"]') || S.editor.author;
    S.editor.method = get('[data-ed="method"]') || S.editor.method;
    S.editor.coffeeName = get('[data-ed="coffeeName"]');
    S.editor.notes = get('[data-ed="notes"]');
    S.submitEmail = get('[data-ed="email"]') || S.submitEmail;
    S.editor.coffeeDose = Number(get('[data-ed="coffeeDose"]')) || 0;
    S.editor.water = Number(get('[data-ed="water"]')) || 0;
    S.editor.temperature = Number(get('[data-ed="temperature"]')) || 0;
    S.editor.ratio = calculateRatio(S.editor.coffeeDose, S.editor.water);
    if (!S.editor.grind) S.editor.grind = { level: 'medium-fine', grinder: null, setting: null };
    S.editor.grind.level = get('[data-ed="grindLevel"]') || S.editor.grind.level;
    S.editor.grind.grinder = get('[data-ed="grinder"]') || null;
    S.editor.grind.setting = get('[data-ed="setting"]') || null;
    S.editor.targetTime.min = get('[data-ed="tmin"]') ? parseTime(get('[data-ed="tmin"]')) : null;
    S.editor.targetTime.max = get('[data-ed="tmax"]') ? parseTime(get('[data-ed="tmax"]')) : null;
    (S.editor.steps || []).forEach(function (step, i) {
      var timeEl = form.querySelector('[data-ed="time"][data-i="' + i + '"]');
      var typeEl = form.querySelector('[data-ed="type"][data-i="' + i + '"]');
      var wEl = form.querySelector('[data-ed="targetWeight"][data-i="' + i + '"]');
      var lEl = form.querySelector('[data-ed="label"][data-i="' + i + '"]');
      if (timeEl) step.time = parseTime(timeEl.value);
      if (typeEl) {
        step.type = typeEl.value;
        if (step.type !== 'pour') step.targetWeight = null;
      }
      if (wEl && step.type === 'pour') step.targetWeight = Number(wEl.value) || 0;
      if (lEl) step.label = lEl.value ? lEl.value : null;
    });
  }

  function saveEditor(andBrew) {
    readEditorFields();
    var v = validateRecipe(S.editor);
    if (!v.ok) {
      paint();
      toast(v.errors[0]);
      return;
    }
    var saved = upsertUser(S.editor);
    S.editor = clone(saved);
    toast('Zapisano');
    if (andBrew) beginBrew(saved);
    else go('#/recipe/' + saved.id);
  }

  function submitCommunity() {
    if (S.submitting) return;
    readEditorFields();
    var v = validateRecipe(S.editor);
    if (!v.ok) {
      paint();
      toast(v.errors[0]);
      return;
    }
    if (!canSubmitAuthor(S.editor.author)) {
      toast(T.submitNeedAuthor);
      return;
    }
    if (!String(S.editor.notes || '').trim()) {
      toast(T.submitNeedNotes);
      return;
    }
    var email = String(S.submitEmail || '').trim();
    var form = document.querySelector('#voitkus-brew-contact') || document.querySelector('[data-brew-contact]');
    if (form) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        toast(T.submitNeedEmail || 'Podaj email — zgłoszenie idzie do palarni.');
        return;
      }
      var savedC = upsertUser(S.editor);
      S.editor = clone(savedC);
      var payloadC = clone(savedC);
      payloadC.source = 'community';
      payloadC.visibility = 'public';
      S.submitting = true;
      paint();
      var nameEl = form.querySelector('[name="contact[name]"]');
      var emailEl = form.querySelector('[name="contact[email]"]');
      var bodyEl = form.querySelector('[name="contact[body]"]');
      if (nameEl) nameEl.value = payloadC.author;
      if (emailEl) emailEl.value = email;
      if (bodyEl) {
        bodyEl.value =
          'Brew Timer · przepis do weryfikacji\n\n' +
          payloadC.author + ' · ' + payloadC.name + ' · ' + payloadC.method + '\n' +
          (payloadC.coffeeName ? payloadC.coffeeName + '\n' : '') + '\n' +
          (payloadC.notes || '') + '\n\n' +
          JSON.stringify(payloadC, null, 2);
      }
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then(function (res) {
        S.submitting = false;
        if (!res.ok && res.status >= 400) {
          paint();
          toast(T.submitFail);
          return;
        }
        markSubmitted(savedC.id);
        paint();
        toast(T.submitted);
      }).catch(function () {
        S.submitting = false;
        paint();
        toast(T.submitFail);
      });
      return;
    }
    if (!cfg.ajaxUrl) {
      toast(T.submitFail);
      return;
    }
    var saved = upsertUser(S.editor);
    S.editor = clone(saved);
    var payload = clone(saved);
    payload.source = 'community';
    payload.visibility = 'public';
    S.submitting = true;
    paint();
    var body = new URLSearchParams();
    body.set('action', 'voitkus_brew_submit');
    body.set('nonce', cfg.nonce || '');
    body.set('recipe', JSON.stringify(payload));
    body.set('website', '');
    fetch(cfg.ajaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: body.toString(),
    }).then(function (res) {
      return res.json().then(function (json) {
        return { ok: res.ok && json && json.success, json: json };
      });
    }).then(function (out) {
      S.submitting = false;
      if (!out.ok) {
        var msg = out.json && out.json.data && out.json.data.message ? out.json.data.message : T.submitFail;
        paint();
        toast(msg);
        return;
      }
      markSubmitted(saved.id);
      paint();
      toast(T.submitted);
    }).catch(function () {
      S.submitting = false;
      paint();
      toast(T.submitFail);
    });
  }

  /* ---------- events ---------- */

  function onClick(e) {
    var dialog = e.target.closest('[data-dialog]');
    var actEl = e.target.closest('[data-act]');
    if (e.target.getAttribute('data-act') === 'close-modal' && !dialog) {
      S.doseModal = null;
      paint();
      return;
    }
    if (!actEl || !root.contains(actEl)) return;
    var act = actEl.getAttribute('data-act');
    var id = actEl.getAttribute('data-id') || '';
    var hash = actEl.getAttribute('data-hash') || '';

    if (act === 'go') { go(hash || '#/'); return; }
    if (act === 'filter') {
      var kind = actEl.getAttribute('data-kind');
      var value = actEl.getAttribute('data-value');
      if (kind === 'source') go(value === 'all' ? '#/recipes' : '#/recipes?source=' + encodeURIComponent(value));
      else { S.filterMethod = value; paint(); }
      return;
    }
    if (act === 'start') {
      var rec = previewRecipe(id) || findRecipe(id);
      if (rec) beginBrew(rec);
      return;
    }
    if (act === 'dose') {
      var r = previewRecipe(id) || findRecipe(id);
      S.doseModal = { id: id, value: r ? r.coffeeDose : 15 };
      paint();
      return;
    }
    if (act === 'close-modal') { S.doseModal = null; paint(); return; }
    if (act === 'apply-dose') {
      var input = root.querySelector('[data-dose-input]');
      var base = findRecipe(id);
      if (base && input) {
        S.scaled[id] = scaleRecipe(base, Number(input.value) || base.coffeeDose);
        S.scaled[id].id = base.id;
      }
      S.doseModal = null;
      paint();
      return;
    }
    if (act === 'customize') { customize(id); return; }
    if (act === 'save') { saveEditor(false); return; }
    if (act === 'save-brew') { saveEditor(true); return; }
    if (act === 'submit-community') { submitCommunity(); return; }
    if (act === 'delete') {
      if (!S.editor) return;
      if (!window.confirm('Usunąć przepis?')) return;
      S.user = S.user.filter(function (x) { return x.id !== S.editor.id; });
      saveUserRecipes();
      S.editor = null;
      go('#/recipes?source=user');
      return;
    }
    if (act === 'step-add') {
      readEditorFields();
      S.editor.steps.push({ id: uid('step'), time: 0, type: 'pour', targetWeight: 0, label: null });
      paint();
      return;
    }
    if (act === 'step-del') {
      readEditorFields();
      S.editor.steps.splice(Number(actEl.getAttribute('data-i')), 1);
      paint();
      return;
    }
    if (act === 'step-up' || act === 'step-down') {
      readEditorFields();
      var i = Number(actEl.getAttribute('data-i'));
      var j = act === 'step-up' ? i - 1 : i + 1;
      if (j < 0 || j >= S.editor.steps.length) return;
      var tmp = S.editor.steps[i];
      S.editor.steps[i] = S.editor.steps[j];
      S.editor.steps[j] = tmp;
      paint();
      return;
    }
    if (act === 'pause') { pauseBrew(); return; }
    if (act === 'resume') { resumeBrew(); return; }
    if (act === 'stop') { stopBrew(); return; }
    if (act === 'step-prev') { pinStep(-1); return; }
    if (act === 'step-next') { pinStep(1); return; }
    if (act === 'skip-count') {
      if (S.brew && S.brew.state === 'countdown') {
        S.brew.state = 'running';
        S.brew.startedAt = Date.now();
        S.brew.pauseAccum = 0;
        lockScreen();
        paint();
      }
      return;
    }
    if (act === 'pref-sound') {
      S.prefs.sound = !S.prefs.sound;
      savePrefs();
      if (S.prefs.sound) beep();
      paint();
      return;
    }
    if (act === 'pref-vib') {
      S.prefs.vibrate = !S.prefs.vibrate;
      savePrefs();
      if (S.prefs.vibrate) buzz();
      paint();
      return;
    }
    if (act === 'resume-active') {
      var active = loadActive();
      if (active) {
        S.brew = active;
        if (S.brew.state === 'running') lockScreen();
        startTick();
        go('#/brew');
      }
      return;
    }
    if (act === 'discard-active') {
      try { localStorage.removeItem(KEY_ACTIVE); } catch (err) { /* ignore */ }
      S.brew = null;
      paint();
      return;
    }
    if (act === 'again') {
      if (S.lastSession) beginBrew(S.lastSession.recipeSnapshot);
      return;
    }
    if (act === 'adjust') {
      if (!S.lastSession) return;
      var adj = clone(S.lastSession.recipeSnapshot);
      adj.id = uid('recipe');
      adj.source = 'user';
      adj.author = 'Ja';
      adj.name = /^mój /i.test(adj.name) ? adj.name : 'Mój ' + adj.name;
      S.editor = adj;
      go('#/edit/' + adj.id);
      return;
    }
    if (act === 'save-session') {
      if (S.lastSession) {
        appendHistory(S.lastSession);
        toast('Zapisano parzenie');
      }
      return;
    }
    if (act === 'save-from-done') {
      if (!S.lastSession) return;
      var copy = clone(S.lastSession.recipeSnapshot);
      copy.id = uid('recipe');
      copy.source = 'user';
      copy.author = 'Ja';
      upsertUser(copy);
      toast('Zapisano przepis');
    }
  }

  function onInput(e) {
    if (!e.target.closest('[data-editor-form]')) return;
    readEditorFields();
    var ed = e.target.getAttribute('data-ed');
    if (ed === 'coffeeDose' || ed === 'water') {
      var ratio = root.querySelector('.brew-timer__ratio');
      if (ratio && S.editor) ratio.textContent = formatRatio(S.editor.coffeeDose, S.editor.water);
    }
  }

  function onChange(e) {
    if (!e.target.closest('[data-editor-form]')) return;
    readEditorFields();
    if (e.target.getAttribute('data-ed') === 'type') paint();
  }

  function onKey(e) {
    if (S.route.name !== 'brew' || !S.brew) return;
    if (e.code === 'Space') {
      e.preventDefault();
      if (S.brew.state === 'running') pauseBrew();
      else if (S.brew.state === 'paused') resumeBrew();
    }
  }

  function syncRoute() {
    S.route = parseHash();
    if (S.route.name === 'create') {
      if (!S.editor || S.route.name === 'create' && findRecipe(S.editor.id) && S.editor.source === 'user' && S.route.id === '') {
        /* keep in-progress create if it isn't a stored recipe */
      }
      if (S.route.name === 'create' && (!S.editor || S.editor._fromEdit)) S.editor = emptyRecipe();
      if (!S.editor) S.editor = emptyRecipe();
    }
    if (S.route.name === 'edit') {
      if (!S.editor || S.editor.id !== S.route.id) {
        var found = findRecipe(S.route.id);
        S.editor = found ? clone(found) : emptyRecipe();
        S.editor.id = S.route.id;
      }
    }
    if (S.route.name === 'brew' && !S.brew) {
      var active = loadActive();
      if (active) {
        S.brew = active;
        startTick();
      } else {
        go('#/');
        return;
      }
    }
    if (S.route.name !== 'brew') {
      document.body.classList.remove('brew-timer-lock');
      if (S.brew && (S.brew.state === 'running' || S.brew.state === 'paused' || S.brew.state === 'countdown')) {
        saveActive();
      }
    }
    paint();
  }

  function onVisibility() {
    if (document.visibilityState === 'visible' && S.brew && S.brew.state === 'running') {
      lockScreen();
      onTick();
    }
  }

  /* ---------- boot ---------- */

  S.official = (Array.isArray(cfg.recipes) ? cfg.recipes : []).map(function (r) {
    return hydrateRecipe(r);
  }).filter(Boolean);

  if (!S.official.length) {
    S.official = [
      normalizeRecipe({
        id: 'voitkus_origami',
        name: 'VOITKUS Origami',
        author: 'VOITKUS',
        source: 'voitkus',
        method: 'origami',
        coffeeDose: 15,
        water: 250,
        temperature: 94,
        grind: { level: 'medium-fine' },
        targetTime: { min: 150, max: 165 },
        steps: [
          { id: 'o1', time: 0, type: 'pour', targetWeight: 50, label: 'Bloom' },
          { id: 'o2', time: 40, type: 'pour', targetWeight: 120, label: null },
          { id: 'o3', time: 70, type: 'pour', targetWeight: 185, label: null },
          { id: 'o4', time: 100, type: 'pour', targetWeight: 250, label: null },
          { id: 'o5', time: 150, type: 'finish', targetWeight: null, label: null },
        ],
      }, 'voitkus'),
    ];
  }

  loadUserRecipes();
  loadPrefs();

  root.addEventListener('click', onClick);
  root.addEventListener('input', onInput);
  root.addEventListener('change', onChange);
  document.addEventListener('keydown', onKey);
  window.addEventListener('hashchange', syncRoute);
  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pagehide', saveActive);

  syncRoute();
})();
